import { getBrand } from './user_helpers';
import get from 'lodash/get';
import { getBrandWinningMerchant } from './user_helpers';

export const getBrandBaseCommissionRate = user => {
  const ownCommissionRate = get(getBrand(user), 'commission_rate');
  const topMerchantForBrand = getBrandWinningMerchant(user);
  const topCommissionRate = get(topMerchantForBrand, 'fullPayout');

  return topMerchantForBrand?.source === 'shopmyshelf' ? ownCommissionRate : topCommissionRate;
};

export const getBrandCommissionRateReturning = user => {
  const brand = getBrand(user);
  const topMerchantForBrand = getBrandWinningMerchant(user);
  return topMerchantForBrand?.source === 'shopmyshelf' ? brand?.commission_rate_returning : null;
};
